import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Auth } from '@freelancer/auth';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ShellGuard implements CanActivate {
  constructor(private auth: Auth, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const shouldBeLoggedIn = route.data.loggedIn;
    return this.auth.isLoggedIn().pipe(
      map(isLoggedIn => {
        if (
          isLoggedIn !== shouldBeLoggedIn &&
          route.parent &&
          route.parent.routeConfig &&
          route.parent.routeConfig.children
        ) {
          // HACK: reverse the route config so the other route goes first
          // https://github.com/angular/angular/issues/16211
          route.parent.routeConfig.children.reverse();
          // then reload this route to access the reversed config
          // tslint:disable-next-line:no-navigate-by-url
          this.router.navigateByUrl(state.url);
        }

        return isLoggedIn === shouldBeLoggedIn;
      }),
    );
  }
}
